/* eslint-disable */
import { useCallback, useContext } from "react";
import initCapitalize from "../../../../../../utils/commonFunctions/initCapitalize";
import "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import { Grid, Select, MenuItem, TextField } from "@material-ui/core";
import EventIcon from "@material-ui/icons/Event";
import CustomHelperTextComponent from "../../../../../shared/customHelperTextComponent/CustomHelperTextComponent";
import { ThemeContext } from "../../../../../../contexts";
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";
import { Validation } from "../../../../../../@types/validation.types";
import { ApproveEnrollment } from "../../../../../../@types/components/enrollmentProps.types";

interface ApproveEnrollmentSectionProps {
	enrollmentDate: string;
	enrollmentStatus?: string;
	effectiveDate?: string;
	handleApproveEffectiveDateChange?: (date: MaterialUiPickersDate, name: string | null | undefined) => void;

	validation?: Validation;
	approveEnrollment?: ApproveEnrollment;
	handleApproveEnrollmentChange?: (
		event: React.ChangeEvent<
			| HTMLInputElement
			| {
					name?: string | undefined;
					value: unknown;
			  }
		>,
		child?: React.ReactNode
	) => void;
	handleApproveEnrollmentDateChange?: any;
}

const ApproveEnrollmentSection = ({
	enrollmentDate,
	enrollmentStatus,
	effectiveDate,
	handleApproveEffectiveDateChange,
	approveEnrollment,
	handleApproveEnrollmentChange,
	handleApproveEnrollmentDateChange,
	validation
}: ApproveEnrollmentSectionProps) => {
	const { theme } = useContext(ThemeContext);
	const handleDateChange = useCallback(() => {}, []);

	const isValidationMode = Boolean(validation); // switch condition
	console.log(enrollmentDate, "effectiveDate=====>", effectiveDate, approveEnrollment);

	return (
		<div className="approve-enrollment">
			<div
				className="theme-divider-grad-mask"
				style={{
					marginTop: "2rem",
					background: `linear-gradient(90deg, ${theme.primary_color} 0 55%, transparent 0 100%) 0 0 / 2rem 1rem`
				}}
			/>

			<div className="theme-plan-section-margin" />

			<Grid container className="theme-plan-section-margin">
				{/* Enrollment Date */}
				<Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
					<div className="details-form-row">
						<div className="details-form-label required">Enrollment Date</div>
						<MuiPickersUtilsProvider utils={DateFnsUtils}>
							<KeyboardDatePicker
								className="from-date-input date-input"
								id="enrollment-date"
								inputVariant="outlined"
								label="Enrollment Date"
								format="MM/dd/yyyy"
								error={false}
								InputProps={{ readOnly: true }}
								InputLabelProps={{ shrink: true }}
								value={enrollmentDate}
								onChange={handleDateChange}
								name="enrollment_date"
								keyboardIcon={<EventIcon style={{ color: "#cccccc" }} />}
								KeyboardButtonProps={{
									"aria-label": "change date"
								}}
								style={{
									pointerEvents: "unset",
									width: "200px",
									borderRadius: 20
								}}
								helperText=""
								disabled
							/>
						</MuiPickersUtilsProvider>
					</div>
				</Grid>

				{/* Effective Date */}
				<Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
					<div className="details-form-row">
						<div className="details-form-label required">Effective Date</div>

						<MuiPickersUtilsProvider utils={DateFnsUtils}>
							<KeyboardDatePicker
								className="from-date-input date-input"
								id="effective-date"
								inputVariant="outlined"
								label="Effective Date"
								placeholder="Enter effective date"
								format="MM/dd/yyyy"
								error={false}
								InputProps={{ readOnly: true }}
								InputLabelProps={{ shrink: true }}
								// value={
								// 	isValidationMode
								// 		? effectiveDate
								// 			? effectiveDate
								// 			: approveEnrollment?.enrollment_status === "REJECTED" ||
								// 			  approveEnrollment?.effective_date === null
								// 			? ""
								// 			: approveEnrollment?.effective_date
								// 		: effectiveDate
								// }

								value={
									isValidationMode
										? effectiveDate
											? effectiveDate
											: approveEnrollment?.enrollment_status === "REJECTED"
											? null
											: null
										: effectiveDate || null
								}
								// value={new Date("2026-03-01")}
								onChange={
									isValidationMode
										? handleApproveEnrollmentDateChange
											? handleApproveEnrollmentDateChange
											: handleApproveEffectiveDateChange
										: handleApproveEffectiveDateChange
								}
								name="effective_date"
								disabled={isValidationMode && approveEnrollment?.enrollment_status === "REJECTED"}
								keyboardIcon={<EventIcon style={{ color: "#7cb342" }} />}
								KeyboardButtonProps={{
									"aria-label": "change date"
								}}
								style={{
									cursor:
										isValidationMode && approveEnrollment?.enrollment_status === "REJECTED"
											? "none"
											: "pointer",
									pointerEvents: "unset",
									width: "200px",
									borderRadius: 20
								}}
								helperText={
									isValidationMode
										? validation?.approveEnrollment?.effective_date ||
										  validation?.approveHOOEnrollment?.effective_date ||
										  ""
										: ""
								}
							/>
						</MuiPickersUtilsProvider>
					</div>
				</Grid>

				{/* Status */}
				<Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
					<div className="details-form-row">
						<div className="details-form-label required">Status</div>

						{isValidationMode ? (
							<>
								<Select
									style={{
										pointerEvents: "unset",
										width: 200,
										textAlign: "left",
										overflowY: "visible"
									}}
									MenuProps={{ style: { zIndex: 35960 } }}
									inputProps={{ "aria-label": "Without label" }}
									value={approveEnrollment?.enrollment_status || ""}
									onChange={handleApproveEnrollmentChange}
									name="enrollment_status"
								>
									<MenuItem value="" disabled>
										Select Value
									</MenuItem>
									{["ACTIVE", "REJECTED"].map((option, index) => (
										<MenuItem value={option} key={index}>
											{initCapitalize(option)}
										</MenuItem>
									))}
								</Select>

								{(validation?.approveEnrollment?.enrollment_status ||
									validation?.approveHOOEnrollment?.enrollment_status) && (
									<CustomHelperTextComponent
										errorText={
											validation?.approveEnrollment?.enrollment_status ||
											validation?.approveHOOEnrollment?.enrollment_status
										}
									/>
								)}
							</>
						) : (
							<TextField
								className="text-field-input"
								id="status-field"
								name="enrollment_status"
								value={initCapitalize(enrollmentStatus || "")}
								variant="outlined"
								InputProps={{ readOnly: true }}
								style={{
									pointerEvents: "unset",
									width: "300px",
									borderRadius: 50
								}}
							/>
						)}
					</div>
				</Grid>
			</Grid>
		</div>
	);
};

export default ApproveEnrollmentSection;
